import Swiper from 'swiper'
import EventBus from '../_event-bus'
import { $, $$ } from '../_utils'

export default class Slider {
  constructor($sliderElement) {
    this.$sliderElement = $sliderElement
    this.$paginationElement = $sliderElement?.nextElementSibling
  }

  addResizeListeners = () => {
    this.pageWidth = document.documentElement.clientWidth

    EventBus.$on('resize', this.watchBreakpoints)
  }
  addPrizesClickListeners = () => {
    if (this.prizesElements.length)
      this.prizesElements.forEach(prize => {
        const button = $('button', prize)
        if (button.className.includes('btn--disabled')) return
        button.addEventListener('click', this.emitAddToCartEvent)
      })
  }

  emitAddToCartEvent = event => {
    EventBus.$emit('add-to-cart', { count: 1, id: parseInt(event.srcElement.dataset.id) })
  }

  breakpointCrossed = (breakpoint, currentPageWidth) => {
    const previousPageWidth = this.pageWidth

    return (
      (previousPageWidth <= breakpoint && currentPageWidth > breakpoint) ||
      (previousPageWidth > breakpoint && currentPageWidth <= breakpoint)
    )
  }
  getPrizes = self => {
    this.prizesElements = $$('.prize', this.$sliderElement)
  }
  getPrizeId = () => {}

  getSwiperNavigation = () =>
    this.$paginationElement?.classList.contains('swiper-pagination')
      ? this.$paginationElement
      : $('.swiper-pagination', this.$paginationElement)

  getSwiperNextButton = () => $('.swiper-button-next', this.$paginationElement)

  getSwiperPreviousButton = () => $('.swiper-button-prev', this.$paginationElement)

  initialiseSlider = () => {
    const self = this
    this.sliderInstance = new Swiper(this.$sliderElement, {
      on: {
        init: () => {
          self.getPrizes(self)
        },
      },
      autoHeight: false,
      setWrapperSize: true,
      loop: true,
      navigation: {
        nextEl: this.getSwiperNextButton(),
        prevEl: this.getSwiperPreviousButton(),
      },
      pagination: {
        el: this.getSwiperNavigation(),
        type: 'bullets',
        clickable: true,
      },
      watchOverflow: true,
      ...this.sliderConfig,
    })
  }

  on = (...args) => {
    this.sliderInstance.on(...args)
  }

  parseSliderConfig = (initialSlide = 0) => {
    this.sliderConfig = {
      initialSlide,
      ...JSON.parse(this.$sliderElement.dataset?.swiperConfig || '{}'),
    }
    this.udpateBreakpoints = JSON.parse(
      this.$sliderElement.dataset?.swiperUpdateBreakpoints || '[]'
    )
  }

  slideTo = (...args) => {
    this.sliderInstance.slideTo(...args)
  }

  reinitialiseSlider = () => {
    this.sliderInstance.destroy()
    this.initialiseSlider()
  }

  watchBreakpoints = () => {
    const currentPageWidth = document.documentElement.clientWidth

    this.udpateBreakpoints.forEach(breakpoint => {
      if (!this.breakpointCrossed(breakpoint, currentPageWidth)) return

      this.reinitialiseSlider()
    })

    this.pageWidth = currentPageWidth
  }

  init(initialSlide) {
    this.parseSliderConfig(initialSlide)
    this.addResizeListeners()
    this.initialiseSlider()
    this.addPrizesClickListeners()
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const $$sliderElements = $$('.swiper-container')
  $$sliderElements.forEach($sliderElement => {
    const slider = new Slider($sliderElement)
    slider.init()
  })
})
